// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format12 } from '../../constants';

/** Seychelles */
const SC: PhoneNumberData = [248, 'SC', 7, format12];

export default SC;
